import React from 'react';

const RefraccionesIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path d="M27.94 7.42V3.73l-9.17 4V3.55H15.6v5.59L3.14 14.52v3.26l12.4 5.59v5.58h3.17v-4.18l9.11 4.12V25.2l-9.12-4 .07-9.89Zm-12.4 12.39-8.25-3.63 8.3-3.52Z" />
  </svg>
);

export default RefraccionesIcon;
